import { useLayoutEffect } from 'react';
import { Button, Card, Form, Input, Row } from 'antd';
import { observer } from 'mobx-react-lite';

import { NotificationsRender } from 'app/common/notifications/features/notifications';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';
import { CanAccess } from 'app/railways/domains/access/features/permissions';
import { TEmployee } from 'app/terminals/domains/employees/core/employee';
import { AvailableEmployees } from 'app/terminals/domains/employees/features/available-employees/available-employees';
import { Stack } from 'app/ui';

type Employee = Pick<TEmployee, 'id' | 'name'>;

type FormFields = {
  name: string;
  employees: Employee[];
};

type ProfileFormProps = {
  onSubmit?: (fields: FormFields) => void;
  values?: Partial<FormFields>;
};

export const ProfileForm = observer(
  ({ onSubmit, values }: ProfileFormProps) => {
    const [form] = Form.useForm();
    const notify = usePageNotify();

    useLayoutEffect(() => {
      values && form.setFieldsValue(values);
    }, [form, values]);

    return (
      <Form layout="vertical" form={form} onFinish={onSubmit}>
        <Stack>
          <Card size="small" title="Данные профиля">
            <Form.Item
              name="name"
              label="Название"
              wrapperCol={{ span: 12 }}
              rules={[
                {
                  required: true,
                  message: 'Пожалуйста, введите название профиля',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Card>
          <Card size="small" title="Сотрудники">
            <Form.Item
              name="employees"
              rules={[
                {
                  required: true,
                  message: 'Пожалуйста, выберите минимум одного сотрудника',
                },
              ]}
            >
              <AvailableEmployees />
            </Form.Item>
          </Card>

          <NotificationsRender notifyStore={notify} />

          <CanAccess perm="PERM_TERMINAL_PROFILE_UPDATE">
            <Card size="small">
              <Row justify="end">
                <Button type="primary" htmlType="submit">
                  Сохранить
                </Button>
              </Row>
            </Card>
          </CanAccess>
        </Stack>
      </Form>
    );
  },
);
